export default __webpack_public_path__ + "static/media/Multi_Detector.9517398f.svg";